<template>
  <v-app>
    <v-app-bar
      app
      :color="color_morado_100"
      dark
      :clipped-left="$vuetify.breakpoint.mdAndUp"
    >
    <v-btn icon @click="drawer = !drawer" v-if="esta_logueado">
      <v-icon>fa-solid fa-bars</v-icon>
    </v-btn>    
      <div>
        <v-img :src="require('@/assets/logo.png')" width="200" />
      </div>

      <v-spacer></v-spacer>

      <v-btn text @click="cerrarSesion()" v-if="esta_logueado">
        <v-icon>fa-solid fa-right-from-bracket</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      app
      :clipped="$vuetify.breakpoint.mdAndUp"
      v-if="esta_logueado"
      v-model="drawer"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6 text-center">
            {{ decryptUsingAES256($store.state.usuario.u2) }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item
          v-for="item in items_pantallas"
          :to="item.to"
          :key="item.nombre"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.nombre }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!--ACCESO-->
        <v-list-group sub-group active-class="purple--text">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Acceso</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="item in item_acceso"
            :to="item.to"
            :key="item.nombre"
            link
          >
            <v-list-item-title>{{ item.nombre }}</v-list-item-title>

            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <!--CATALOGOS-->
        <v-list-group sub-group active-class="purple--text">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Catalogos</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="item in items_catalogos"
            :to="item.to"
            :key="item.nombre"
            link
          >
            <v-list-item-title>{{ item.nombre }}</v-list-item-title>

            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <!--OTROS-->
        <v-list-item
          v-for="item in items_otros"
          :to="item.to"
          :key="item.nombre"
          link
          active-class="purple--text"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.nombre }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import confi_colores from "./config/colores";
import * as CryptoJS from "crypto-js";

export default {
  data: () => ({
    drawer: true,
    items_pantallas: [
      { nombre: "Bienvenido", to: "/", icon: "fa-solid fa-house" },
    ],
    item_acceso: [
      {
        nombre: "Usuarios",
        to: "/usuarios",
        icon: "fa-solid fa-users",
      },
      {
        nombre: "Roles",
        to: "/roles",
        icon: "fa-solid fa-gears",
      },
    ],
    items_catalogos: [
      {
        nombre: "Productos",
        to: "/productos",
        icon: "fa-solid fa-box-archive",
      },
    ],
    items_otros: [
      {
        nombre: "Facturación",
        to: "/facturacion",
        icon: "fa-solid fa-receipt",
      },
      {
        nombre: "Ventas Diarias",
        to: "/ventas_diarias",
        icon: "fa-solid fa-square-poll-vertical",
      },
      /*{
        nombre: "Corte Diario",
        to: "/corte_diario",
        icon: "fa-solid fa-square-poll-vertical",
      },*/
      {
        nombre: "Corte Diario",
        to: "/corte_diario_v2",
        icon: "fa-solid fa-square-poll-vertical",
      },
    ],
  }),
  computed: {
    esta_logueado() {
      if (this.$store.state.usuario) {
        return true;
      } else {
        return false;
      }
    },
    color_morado_100() {
      return confi_colores.morado_100;
    },
  },
  created() {
    //console.log(this.$store.state.usuario);    
    this.$store.dispatch("autoLogin");
  },
  methods: {
    cerrarSesion() {
      this.$store.dispatch("salir");
    },
    decryptUsingAES256(decString) {
      this.key = CryptoJS.enc.Utf8.parse("4512631236589784");
      this.iv = CryptoJS.enc.Utf8.parse("4512631236589784");

      var decrypted = CryptoJS.AES.decrypt(decString, this.key, {
        keySize: 128 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      //console.log(decrypted.toString(CryptoJS.enc.Utf8));

      return decrypted.toString(CryptoJS.enc.Utf8);
    },
  },
};
</script>
